import type { Level } from '@outpost/api-client';

import { cn } from '@/lib/utils';
import { levelBackground } from '@/lib/format';

/** Severity pill. Colour plus text, never colour alone, for accessibility. */
export function LevelBadge({ level, className }: { level: Level; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-sm px-1.5 py-0.5 text-[11px] font-medium uppercase tracking-wide',
        'bg-secondary text-secondary-foreground',
        className,
      )}
    >
      <span className={cn('size-1.5 rounded-full', levelBackground(level))} aria-hidden />
      {level}
    </span>
  );
}
